module.exports = __webpack_public_path__ + "static/media/creative_dna_design_sphere.9e1dc3aa.png";